import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SagToolTipDirective } from './sag-tool-tip.directive';
import { OnLoadComponentDirective } from './webcomponents/on-load-component.directive';
import { EditwrapperDirective } from './controledit/editwrapper.directive';
import { ImageloadDirective } from './webcomponents/imageload.directive';
import { NumbersOnlyDirective } from './numbers-only.directive';

@NgModule({
  declarations: [
    SagToolTipDirective,
    OnLoadComponentDirective,
    EditwrapperDirective,
    ImageloadDirective,
    NumbersOnlyDirective,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SagToolTipDirective,
    OnLoadComponentDirective,
    EditwrapperDirective,
    ImageloadDirective,
    NumbersOnlyDirective
  ]
})
export class DirectivesModule { }
